import { cn } from "@krea/shared/utils";

const FILLED = "#FBBC04";
const EMPTY = "#DCDCE6";

const STAR_PATH =
  "M8.386 0.691C8.685 -0.23 9.989 -0.23 10.288 0.691L11.807 5.365C11.94 5.777 12.324 6.056 12.758 6.056H17.672C18.641 6.056 19.043 7.296 18.26 7.865L14.284 10.754C13.934 11.008 13.787 11.46 13.921 11.872L15.439 16.545C15.739 17.467 14.684 18.233 13.9 17.663L9.925 14.775C9.574 14.52 9.1 14.52 8.749 14.775L4.773 17.663C3.99 18.233 2.935 17.467 3.235 16.545L4.753 11.872C4.887 11.46 4.74 11.008 4.39 10.754L0.414 7.865C-0.37 7.296 0.033 6.056 1.002 6.056H5.916C6.349 6.056 6.733 5.777 6.867 5.365L8.386 0.691Z";

function normalizeScore(score: number): number {
  const clamped = Math.max(0, Math.min(5, score));
  return Math.round(clamped * 2) / 2;
}

interface IGoogleStarsProps {
  score?: number;
  className?: string;
}

export const GoogleStars = ({ score = 5, className }: IGoogleStarsProps) => {
  const normalized = normalizeScore(score);
  const filledCount = Math.floor(normalized);
  const hasHalf = normalized % 1 !== 0;

  return (
    <div className={cn("inline-flex h-full w-auto", className)}>
      <svg
        viewBox="0 0 115 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-auto object-contain"
        // Decorative: the exact score is rendered as text by the consumer. A
        // label here would announce the half-star-ROUNDED value (4.7 → 4.5).
        aria-hidden="true"
        focusable="false"
      >
        {[0, 1, 2, 3, 4].map((i) => {
          const offset = i * 24;
          const isFilled = i < filledCount;
          const isHalf = i === filledCount && hasHalf;

          if (isHalf) {
            return (
              <g key={i} transform={`translate(${offset}, 0)`}>
                <path d={STAR_PATH} fill={EMPTY} />
                <path
                  d={STAR_PATH}
                  fill={FILLED}
                  style={{ clipPath: "inset(0 50% 0 0)" }}
                />
              </g>
            );
          }

          return (
            <path
              key={i}
              d={STAR_PATH}
              fill={isFilled ? FILLED : EMPTY}
              transform={`translate(${offset}, 0)`}
            />
          );
        })}
      </svg>
    </div>
  );
};
